// import React from "react";
// import { FaCheck, FaTimes } from "react-icons/fa";

// const Pricing = () => {
//   const pricingTiers = [
//     {
//       name: "Basic",
//       price: "$150",
//       description: "Great for pros needing automation and tailored AI interactions.",
//       features: {
//         "24/7 Availability": true,
//         "Basic Conversational Abilities": true,
//         "Security and Privacy": true,
//         "Personalization": true,
//         "Task Automation": true,
//         "Speed of Response": false,
//         "NLP Accuracy": false,
//         "Emotional Intelligence": false,
//         "Contextual Awareness": false,
//         "Multilingual Support": false,
//       },
//       buttonText: "Get Started",
//       buttonLink: "https://dataspeckle.com/contact.html",
//     },
//     {
//       name: "Standard",
//       price: "$500",
//       description: "Suits teams wanting fast responses and advanced AI accuracy.",
//       features: {
//         "24/7 Availability": true,
//         "Basic Conversational Abilities": true,
//         "Security and Privacy": true,
//         "Personalization": true,
//         "Task Automation": true,
//         "Speed of Response": true,
//         "NLP Accuracy": true,
//         "Emotional Intelligence": true,
//         "Contextual Awareness": false,
//         "Multilingual Support": false,
//       },
//       buttonText: "Get Started",
//       buttonLink: "https://dataspeckle.com/contact.html",
//     },
//     {
//       name: "Enterprise",
//       price: "$1000",
//       description: "Ideal for firms needing deep AI with contextual understanding.",
//       features: {
//         "24/7 Availability": true,
//         "Basic Conversational Abilities": true,
//         "Security and Privacy": true,
//         "Personalization": true,
//         "Task Automation": true,
//         "Speed of Response": true,
//         "NLP Accuracy": true,
//         "Emotional Intelligence": true,
//         "Contextual Awareness": true,
//         "Multilingual Support": false,
//       },
//       buttonText: "Get Started",
//       buttonLink: "https://dataspeckle.com/contact.html",
//     },
//     {
//       name: "Customizable",
//       price: "Contact Us",
//       description: "Perfect for businesses seeking fully custom AI solutions.",
//       features: {
//         "24/7 Availability": true,
//         "Basic Conversational Abilities": true,
//         "Security and Privacy": true,
//         "Personalization": true,
//         "Task Automation": true,
//         "Speed of Response": true,
//         "NLP Accuracy": true,
//         "Emotional Intelligence": true,
//         "Contextual Awareness": true,
//         "Multilingual Support": true,
//       },
//       buttonText: "Contact Us",
//       buttonAction: () =>
//         document.getElementById("contact").scrollIntoView({ behavior: "smooth" }),
//     },
//   ];

//   const featuresList = [
//     "24/7 Availability",
//     "Basic Conversational Abilities",
//     "Security and Privacy",
//     "Personalization",
//     "Task Automation",
//     "Speed of Response",
//     "NLP Accuracy",
//     "Emotional Intelligence",
//     "Contextual Awareness",
//     "Multilingual Support",
//   ];

//   return (
//     <section id="pricing" className="bg-gray-100 py-16 px-6">
//       <div className="max-w-6xl mx-auto text-center">
//         <h2 className="text-3xl md:text-4xl font-serif font-bold text-gray-800 mb-6 animate-fade-in">
//           Subscription Plans
//         </h2>
//         <p className="text-lg md:text-xl text-gray-600 mb-4 animate-fade-in">
//           Choose the Perfect Plan for Your Needs
//         </p>
//         <p className="text-gray-600 max-w-3xl mx-auto mb-8 animate-fade-in">
//           At Effie, our mission is to revolutionize industries by harnessing the power of technology, innovation, and strategic development. We believe in leveraging these pillars to unlock enduring value and propel sustainable economic growth in every sector.
//         </p>
//         <div className="bg-white p-6 rounded-lg shadow-md mb-8 animate-fade-in">
//           <p className="text-gray-600">
//             Try our <span className="text-cyan-500 font-bold">FREE</span> plan – perfect for individuals exploring basic AI features with 24/7 availability, basic conversational abilities, and robust security & privacy.
//           </p>
//         </div>

//         {/* Pricing Cards */}
//         <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
//           {pricingTiers.map((tier, index) => (
//             <div
//               key={index}
//               className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-all animate-fade-in"
//               style={{ animationDelay: `${index * 0.2}s` }}
//             >
//               <h3 className="text-xl font-semibold text-gray-800 mb-2">
//                 {tier.name}
//               </h3>
//               <div className="flex justify-center items-baseline mb-4">
//                 <span className="text-3xl font-bold text-gray-800">{tier.price}</span>
//                 {tier.price !== "Contact Us" && (
//                   <span className="text-gray-500 ml-1">/month</span>
//                 )}
//               </div>
//               <p className="text-gray-600 mb-4">{tier.description}</p>
//               <ul className="space-y-2 text-left text-gray-600 mb-6">
//                 {featuresList.map((feature, i) => (
//                   <li key={i} className="flex items-center space-x-2">
//                     {tier.features[feature] ? (
//                       <FaCheck className="text-cyan-500" />
//                     ) : (
//                       <FaTimes className="text-gray-400" />
//                     )}
//                     <span>{feature}</span>
//                   </li>
//                 ))}
//               </ul>
//               {tier.buttonLink ? (
//                 <a
//                   href={tier.buttonLink}
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="block px-4 py-2 bg-cyan-500 hover:bg-cyan-600 transition-colors duration-300 text-white font-medium rounded-lg text-center"
//                 >
//                   {tier.buttonText}
//                 </a>
//               ) : (
//                 <button
//                   onClick={tier.buttonAction}
//                   className="block w-full px-4 py-2 bg-cyan-500 hover:bg-cyan-600 transition-colors duration-300 text-white font-medium rounded-lg text-center"
//                 >
//                   {tier.buttonText}
//                 </button>
//               )}
//             </div>
//           ))}
//         </div>
//       </div>

//       {/* Global Styles for Animations */}
//       <style jsx global>{`
//         @keyframes fade-in {
//           from {
//             opacity: 0;
//           }
//           to {
//             opacity: 1;
//           }
//         }
//         .animate-fade-in {
//           animation: fade-in 1s ease-out forwards;
//         }
//       `}</style>
//     </section>
//   );
// };

// export default Pricing;

import React from "react";
import { FaCheck, FaTimes } from "react-icons/fa";

const Pricing = () => {
  const pricingTiers = [
    {
      name: "Basic",
      price: "$150",
      description:
        "Great for pros needing automation and tailored AI interactions.",
      features: {
        "24/7 Availability": true,
        "Basic Conversational Abilities": true,
        "Security and Privacy": true,
        Personalization: true,
        "Task Automation": true,
        "Speed of Response": false,
        "NLP Accuracy": false,
        "Emotional Intelligence": false,
        "Contextual Awareness": false,
        "Multilingual Support": false,
      },
      buttonText: "Get Started",
      buttonLink: "https://dataspeckle.com/contact.html",
    },
    {
      name: "Standard",
      price: "$500",
      description:
        "Suits teams wanting fast responses and advanced AI accuracy.",
      features: {
        "24/7 Availability": true,
        "Basic Conversational Abilities": true,
        "Security and Privacy": true,
        Personalization: true,
        "Task Automation": true,
        "Speed of Response": true,
        "NLP Accuracy": true,
        "Emotional Intelligence": true,
        "Contextual Awareness": false,
        "Multilingual Support": false,
      },
      buttonText: "Get Started",
      buttonLink: "https://dataspeckle.com/contact.html",
    },
    {
      name: "Enterprise",
      price: "$1000",
      description:
        "Ideal for firms needing deep AI with contextual understanding.",
      features: {
        "24/7 Availability": true,
        "Basic Conversational Abilities": true,
        "Security and Privacy": true,
        Personalization: true,
        "Task Automation": true,
        "Speed of Response": true,
        "NLP Accuracy": true,
        "Emotional Intelligence": true,
        "Contextual Awareness": true,
        "Multilingual Support": false,
      },
      buttonText: "Get Started",
      buttonLink: "https://dataspeckle.com/contact.html",
    },
    {
      name: "Customizable",
      price: "Contact Us",
      description: "Perfect for businesses seeking fully custom AI solutions.",
      features: {
        "24/7 Availability": true,
        "Basic Conversational Abilities": true,
        "Security and Privacy": true,
        Personalization: true,
        "Task Automation": true,
        "Speed of Response": true,
        "NLP Accuracy": true,
        "Emotional Intelligence": true,
        "Contextual Awareness": true,
        "Multilingual Support": true,
      },
      buttonText: "Contact Us",
      buttonAction: () =>
        document
          .getElementById("contact")
          .scrollIntoView({ behavior: "smooth" }),
    },
  ];

  const featuresList = [
    "24/7 Availability",
    "Basic Conversational Abilities",
    "Security and Privacy",
    "Personalization",
    "Task Automation",
    "Speed of Response",
    "NLP Accuracy",
    "Emotional Intelligence",
    "Contextual Awareness",
    "Multilingual Support",
  ];

  return (
    <section id="pricing" className="bg-gray-100 py-16 px-6">
      <div className="max-w-6xl mx-auto text-center">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-gray-800 mb-6 animate-fade-in">
          Subscription Plans
        </h2>
        <p className="text-lg md:text-xl text-gray-600 mb-4 animate-fade-in">
          Choose the Perfect Plan for Your Needs
        </p>
        <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto mb-8 animate-fade-in">
          At Effie, our mission is to revolutionize industries by harnessing the
          power of technology, innovation, and strategic development. We believe
          in leveraging these pillars to unlock enduring value and propel
          sustainable economic growth in every sector.
        </p>
        <div className="bg-white p-6 rounded-lg shadow-md mb-8 animate-fade-in">
          <p className="text-lg text-gray-600">
            Try our <span className="text-cyan-500 font-bold">FREE</span> plan –
            perfect for individuals exploring basic AI features with 24/7
            availability, basic conversational abilities, and robust security &
            privacy.
          </p>
        </div>

        {/* Pricing Cards */}
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
          {pricingTiers.map((tier, index) => (
            <div
              key={index}
              className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-all animate-fade-in"
              style={{ animationDelay: `${index * 0.2}s` }}
            >
              <h3 className="text-xl font-semibold text-gray-800 mb-2">
                {tier.name}
              </h3>
              <div className="flex justify-center items-baseline mb-4">
                <span className="text-3xl font-bold text-gray-800">
                  {tier.price}
                </span>
                {tier.price !== "Contact Us" && (
                  <span className="text-gray-500 ml-1">/month</span>
                )}
              </div>
              <p className="text-lg text-gray-600 mb-4">{tier.description}</p>
              <ul className="space-y-2 text-lg text-left text-gray-600 mb-6">
                {featuresList.map((feature, i) => (
                  <li key={i} className="flex items-center space-x-2">
                    {tier.features[feature] ? (
                      <FaCheck className="text-cyan-500" />
                    ) : (
                      <FaTimes className="text-gray-400" />
                    )}
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
              {tier.buttonLink ? (
                <a
                  href={tier.buttonLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block px-4 py-2 bg-cyan-500 hover:bg-cyan-600 transition-colors duration-300 text-white text-lg font-medium rounded-lg text-center"
                >
                  {tier.buttonText}
                </a>
              ) : (
                <button
                  onClick={tier.buttonAction}
                  className="block w-full px-4 py-2 bg-cyan-500 hover:bg-cyan-600 transition-colors duration-300 text-white text-lg font-medium rounded-lg text-center"
                >
                  {tier.buttonText}
                </button>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Global Styles for Animations */}
      <style>{`
        @keyframes fade-in {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }
        .animate-fade-in {
          animation: fade-in 1s ease-out forwards;
        }
      `}</style>
    </section>
  );
};

export default Pricing;
